import React from "react"
import styles from "./style.module.css"
import img1 from "./image/errorBoundary_1.png"
import img3 from "./image/errorBoundary_3.png"
import img4 from "./image/errorBoundary_4.png"
import img6 from "./image/errorBoundary_6.png"
import img7 from "./image/errorBoundary_7.png"
import { Button, Alert, Space } from "antd"
import _ from "lodash"

const ErrorBoundaryLayout = ({ error, resetErrorBoundary }) => {
  const copyError = (e) => {
    navigator.clipboard.writeText(e)
  }
  const refresh = () => {
    window.location.reload()
  }
  const randomPic = _.shuffle([img1, img3, img4, img6, img7])
  return (
    <div className={styles.errorBoundaryLayoutContainer}>
      <div className={styles.content}>
        <img className={styles.pic} src={randomPic[0]} />
        <div className={styles.msg}>
          <Alert
            message="很抱歉，處理資料時發生錯誤，請回報系統管理員，謝謝。"
            type="warning"
            // onClose={onClose}
            action={
              <Space>
                <Button
                  size="small"
                  type="dashed"
                  onClick={() => copyError(error)}
                >
                  複製錯誤訊息
                </Button>
                <Button size="small" type="dashed" onClick={refresh}>
                  重新整理
                </Button>
              </Space>
            }
          />
        </div>
      </div>
    </div>
  )
}

export default ErrorBoundaryLayout
